(() => {
  const configElement = document.getElementById('CommerceConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  let changing = false;
  const sectionIds = () => [...new Set([...document.querySelectorAll('[data-cart-root]')].map(root => root.dataset.sectionId))];
  const announce = text => { const status = document.getElementById('StoreStatus'); if (status) status.textContent = text; };
  const openCart = trigger => {
    if (!config.drawer) { location.assign(config.cart); return; }
    document.dispatchEvent(new CustomEvent('misa:open-drawer', {detail:{id:'CartDrawer',trigger}}));
  };
  const render = sections => {
    let count, label;
    for (const id of sectionIds()) {
      if (!sections?.[id]) throw new Error(config.error);
      const page = new DOMParser().parseFromString(sections[id], 'text/html');
      const next = page.querySelector('[data-cart-root]');
      const current = [...document.querySelectorAll('[data-cart-root]')].find(root => root.dataset.sectionId === id);
      if (!next || !current) throw new Error(config.error);
      count = Number(next.dataset.itemCount); label = next.dataset.cartLabel;
      current.replaceWith(next);
    }
    document.querySelectorAll('[data-cart-link]').forEach(link => {
      link.setAttribute('aria-label', label);
      let dot = link.querySelector('.cart-dot');
      if (count > 0 && !dot) { dot = document.createElement('span'); dot.className = 'cart-dot'; dot.setAttribute('aria-hidden','true'); link.append(dot); }
      if (!count) dot?.remove();
    });
  };
  const refresh = async () => {
    const url = new URL(config.cart, location.origin); url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(config.error);
    render(await response.json());
  };
  const cartError = message => document.querySelectorAll('[data-cart-error]').forEach(error => {error.textContent = message;error.hidden = false;});
  const lock = () => {
    const disabled = [];
    document.querySelectorAll('[data-cart-root]').forEach(root => {
      root.setAttribute('aria-busy','true');
      root.querySelectorAll('button,input').forEach(control => {if(!control.disabled){disabled.push(control);control.disabled = true;}});
    });
    return () => {disabled.forEach(control => {if(control.isConnected)control.disabled=false;});document.querySelectorAll('[data-cart-root]').forEach(root=>root.removeAttribute('aria-busy'));};
  };
  const change = async (key, quantity, focusId) => {
    if (changing) return;
    changing = true;
    const unlock = lock();
    try {
      const response = await fetch(`${config.change}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:sectionIds(),sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.errors) throw Object.assign(new Error(), {userMessage:result.description || result.message || config.error});
      render(result.sections);announce(config.updated);
      if(focusId)document.getElementById(focusId)?.focus({preventScroll:true});
      if(!document.activeElement || document.activeElement===document.body)document.querySelector('#CartDrawer[open] [data-close-drawer]')?.focus({preventScroll:true});
    } catch (error) {
      try {await refresh();} catch {}
      cartError(error.userMessage || config.uncertain);
    } finally {unlock();changing = false;}
  };
  document.addEventListener('click', event => {
    const cartLink = event.target.closest('[data-cart-link]');
    if (cartLink && config.drawer && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      refresh().catch(() => cartError(config.error));
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && !event.metaKey && !event.ctrlKey) {event.preventDefault();change(remove.dataset.lineKey,0);}
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('.quantity-control').querySelector('input');
      const minimum = Number(input.dataset.minimum) || 1;
      let value = Number(input.value) + Number(stepper.dataset.quantityStep) * (Number(input.step) || 1);
      if (value < minimum) value = Number(stepper.dataset.quantityStep) < 0 ? 0 : minimum;
      if(input.max && value>Number(input.max))return;
      change(input.dataset.lineKey,Math.max(0,value),input.id);
    }
  });
  document.addEventListener('change',event=>{
    const input=event.target.closest('[data-cart-quantity]');
    if(!input)return;
    const value=Number(input.value), minimum=Number(input.dataset.minimum)||1;
    if(!input.checkValidity() || (value>0 && value<minimum)){input.reportValidity();return;}
    change(input.dataset.lineKey,value,input.id);
  });
  // Cancel native submission early for product forms handled through Ajax.
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-product-form]');
    if(!form)return;
    event.preventDefault();
    if(form.dataset.submitting==='true')return;
    const trigger=event.submitter || form.querySelector('[name="add"]');
    const product=form.closest('misa-product');
    const buttons=[...product.querySelectorAll('[name="add"]')];
    if(trigger?.disabled)return;
    form.dataset.submitting='true';
    const data=new FormData(form);
    buttons.forEach(button=>button.disabled=true);
    const error=form.querySelector('[data-product-error]');error.hidden=true;
    data.set('sections',sectionIds().join(','));data.set('sections_url',location.pathname);
    let accepted=false;
    try{
      const response=await fetch(`${form.action}.js`,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
      const result=await response.json();
      if(!response.ok || result.status)throw Object.assign(new Error(), {userMessage:result.description || result.message || config.error});
      accepted=true;render(result.sections);announce(config.added);openCart(trigger);
    }catch(problem){
      try{await refresh();}catch{}
      error.textContent=accepted?config.uncertain:(problem.userMessage || config.uncertain);error.hidden=false;
      if(accepted)openCart(trigger);
    }finally{form.dataset.submitting='false';buttons.forEach(button=>button.disabled=false);}
  }, {capture:true});
})();
